var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectedEmojiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.384 0.998225C10.8218 1.43596 10.8218 2.14567 10.384 2.58341L5.42989 7.53754C4.99215 7.97528 4.28244 7.97528 3.8447 7.53754L0.855647 4.54849C0.41791 4.11075 0.41791 3.40104 0.855647 2.9633C1.29338 2.52556 2.0031 2.52556 2.44083 2.9633L4.63729 5.15976L8.79883 0.998225C9.23657 0.560488 9.94628 0.560488 10.384 0.998225Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedEmojiIcon);
export default __webpack_public_path__ + "static/media/selectedEmojiIcon.7e6839ff492f2612a56b6a33942b1a7b.svg";
export { ForwardRef as ReactComponent };